import { client } from 'api/apiClient';
import { RequestAccess } from 'types/requestAccess';

export const requestAccess = async (params: RequestAccess): Promise<void> => {
  await client.post('/enterprise-service/v1/dashboard/request-access', params);
};

export default requestAccess;
